"use client";
import { trackContact } from "../../lib/site";

import React, { useEffect, useRef } from "react";
import { FaTimes, FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

interface ContactPopupProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

export default function ContactPopup({ isOpen, setIsOpen }: ContactPopupProps) {
  const dialogRef = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const dialog = dialogRef.current;
    if (isOpen) dialog?.showModal();
    else dialog?.close();
    if (!isOpen) return;
    const previous = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = previous; };
  }, [isOpen]);

  return (
    <dialog ref={dialogRef} aria-labelledby="contact-dialog-title" onCancel={() => setIsOpen(false)} onClick={(event) => { if (event.target === event.currentTarget) setIsOpen(false); }} className="m-auto w-[calc(100%_-_2rem)] max-w-md max-h-[90dvh] overflow-y-auto rounded-2xl p-0 backdrop:bg-slate-950/60">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md overflow-hidden">
        <div className="flex justify-between items-center p-4 bg-brand-600 text-white">
          <h3 id="contact-dialog-title" className="text-lg font-medium">Contact Us</h3>
          <button aria-label="Close contact options" onClick={() => setIsOpen(false)} className="text-white hover:text-brand-100">
            <FaTimes />
          </button>
        </div>

        <div className="p-6">
          <div className="mb-6">
            <p className="text-center text-gray-700 mb-4">Feel free to contact us using the information below or visit our contact page for more options.</p>
          </div>

          <div className="space-y-4">
            {/* Phone Card */}
            <div className="bg-gray-50 rounded-lg p-4 shadow-sm">
              <FaPhone size={28} className="text-brand-600 mb-2" />
              <div>
                <div className="text-xs uppercase tracking-wide text-gray-500 font-semibold mb-1">Phone</div>
                <a href="tel:+919907036906" onClick={() => trackContact("call")} className="text-gray-800 font-medium hover:text-brand-600">
                  +91 99070 36906
                </a>
              </div>
            </div>
            {/* Email Card */}
            <div className="bg-gray-50 rounded-lg p-4 shadow-sm">
              <FaEnvelope size={28} className="text-brand-600 mb-2" />
              <div>
                <div className="text-xs uppercase tracking-wide text-gray-500 font-semibold mb-1">Email</div>
                <a href="mailto:sales@litpl.com" onClick={() => trackContact("email")} className="text-gray-800 font-medium hover:text-brand-600">
                  sales@litpl.com
                </a>
              </div>
            </div>
            {/* Address Card */}
            <div className="bg-gray-50 rounded-lg p-4 shadow-sm">
              <FaMapMarkerAlt size={28} className="text-brand-600 mb-2" />
              <div>
                <div className="text-xs uppercase tracking-wide text-gray-500 font-semibold mb-1">Address</div>
                <div className="text-gray-800 font-medium">Head office: Bhilai, Chhattisgarh, India</div><div className="mt-1 text-xs text-gray-500">Clients across Africa and India · WhatsApp is the fastest channel</div>
              </div>
            </div>
          </div>

          <div className="mt-6">
            <a href="/contact" className="w-full bg-brand-600 text-white py-2 px-4 rounded-md hover:bg-brand-700 transition-colors focus:ring-2 focus:ring-offset-2 focus:ring-brand-500 block text-center">
              Visit Contact Page
            </a>
          </div>
        </div>
      </div>
    </dialog>
  );
}


